module.exports = __webpack_public_path__ + "img/msg_carousel_2.d19875c4.jpg";